// 顶级状态

export const SET_AREA_CONFIG = 'SET_AREA_CONFIG'; // 区域配置

export const SET_DEBUG = 'SET_DEBUG'; // debug

export const SET_TITLE = 'SET_TITLE'; // 标题

export const SET_SHARE_WECHAT = 'SET_SHARE_WECHAT'; // 微信分享遮罩层

export const SET_VISIBLE_TOP = 'SET_VISIBLE_TOP'; // 顶部导航栏

export const SET_NAVIGATION_APP = 'SET_NAVIGATION_APP'; // 打开APP导航栏

export const SET_HIDE_TOP_ROUTERS = 'SET_HIDE_TOP_ROUTERS'; // 隐藏顶部导航栏路由

// =============  user userInfo 用户状态  =============

export const USER_USERINFO_CLEAR = 'USER_USERINFO_CLEAR'; // 用户信息清除

export const USER_USERINFO_UPDATE = 'USER_USERINFO_UPDATE'; // 用户信息更新

// =============  user register 用户注册信息状态  =============

export const USER_REGISTER_CLEAR = 'USER_REGISTER_CLEAR'; // 注册信息清除

export const USER_REGISTER_UPDATE = 'USER_REGISTER_UPDATE'; // 注册信息更新

// =============  user register wechat 微信用户信息绑定  =============

export const USER_REGISTER_WECHAT_CLEARN = 'USER_REGISTER_WECHAT_CLEARN'; // 微信注册信息清除

export const USER_REGISTER_WECHAT_UPDATE = ''; // 微信注册信息清除

// =============  asset 资产状态  =============

export const AUDIO_PAUSED = 'AUDIO_PAUSED'; // 已暂停
export const AUDIO_PLAYED = 'AUDIO_PLAYED'; // 已播放
export const AUDIO_SRC = 'AUDIO_SRC'; // 更改路径

// =============  帮助  =============

export const HELP_CLEAR = 'HELP_CLEAR'; // 清除数据
export const HELP_UPDATE = 'HELP_UPDATE'; // 更新数据

// =============  解绑申请  =============

export const UNBINDING_CLEAR = 'UNBINDING_CLEAR'; // 清除数据
export const UNBINDING_UPDATE = 'UNBINDING_UPDATE'; // 更新数据

export const SET_LOCATION = 'SET_LOCATION'; //更新经纬度
